import { HorseGeneralTipsModel } from './HorseGeneralTipsModel';
import { HorseTipsterModel } from './HorseTipsterModel';
import { HorseModel } from "./HorseModel";
import { HorseBetInfoModel } from './HorseBetInfoModel';

export class HorseInRaceTipsModel extends HorseGeneralTipsModel {
  raceNum: number;
  raceId: number;
  wpStrategy: number;
  wpHorses: Array < HorseModel > ;
  qqpStrategy: number;
  qqpBankerHorses: Array < HorseModel > ;
  qqpSelHorses: Array < HorseModel > ;
  confidenceLevel: number;
  betInfo: HorseBetInfoModel;
  profitMargin: string;
  dividend: number = -1;
  allowUpdate: boolean;

  constructor(id: number, raceNum: number, raceId: number, tipster: HorseTipsterModel, price: number, notes: string,
    availableForPurchase: boolean, purchased: boolean, voucherCost: number, allowRefund: boolean,
    createDate: string, postDate: string, status: number,
    wpStrategy: number, wpHorses: Array < HorseModel >, qqpStrategy: number,
    qqpBankerHorses: Array < HorseModel >, qqpSelHorses: Array < HorseModel >,
    confidenceLevel: number, betInfo: HorseBetInfoModel, profitMargin: string, dividend: number, allowUpdate: boolean, imgSrc: string,
    image1: string, image2: string, image3: string) {
    super(id, tipster, price, notes, availableForPurchase, purchased, voucherCost, allowRefund, createDate, postDate, status, imgSrc, image1, image2, image3);
    this.raceNum = raceNum;
    this.raceId = raceId;
    this.wpStrategy = wpStrategy;
    this.wpHorses = wpHorses;
    this.qqpStrategy = qqpStrategy;
    this.qqpBankerHorses = qqpBankerHorses;
    this.qqpSelHorses = qqpSelHorses;
    this.confidenceLevel = confidenceLevel;
    this.betInfo = betInfo;
    this.profitMargin = profitMargin;
    this.dividend = dividend;
    this.createDate = createDate;
    this.postDate = postDate;
    this.status = status;
    this.allowUpdate = allowUpdate;
  }

}



// WEBPACK FOOTER //
// ./src/model/horse/HorseInRaceTipsModel.ts